<template>
  <div class="file-preview-tile-context-menu">
    <div class="divide-gray-lighten-2 divide-y">
      <ContextMenuItem @click="downloadFile">
        <FontAwesomeIcon :icon="['fas', 'download']" />
        <span>Downloaden</span>
      </ContextMenuItem>
      <ContextMenuItem
        v-if="modelValue.file.isImage()"
        :loading="roateLoader"
        @click="rotateFile()"
      >
        <FontAwesomeIcon :icon="['fas', 'rotate-right']" />
        <span>Roteren</span>
        <template #submenu>
          <ContextMenuItem :loading="roateLoader" @click="rotateFile(90)">
            Roteer 90º
          </ContextMenuItem>
          <ContextMenuItem :loading="roateLoader" @click="rotateFile(180)">
            Roteer 180º
          </ContextMenuItem>
          <ContextMenuItem :loading="roateLoader" @click="rotateFile(270)">
            Roteer 270º
          </ContextMenuItem>
        </template>
      </ContextMenuItem>
      <ContextMenuItem
        class="hover:text-error"
        :disabled="!!deleteDisabledReason"
        :title="deleteDisabledReason"
        @click="removeFileRelation"
      >
        <FontAwesomeIcon :icon="['fas', 'trash-can']" />
        <span>Verwijderen</span>
      </ContextMenuItem>
      <p v-if="deleteDisabledReason" class="max-w-64 px-2 py-1.5 text-xs">
        {{ deleteDisabledReason }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, inject, ref } from "vue"
import { FileRelation } from "@/models/file/file-relation.model"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

import ContextMenuItem from "@/components/context_menu/ContextMenuItem.vue"
import { FileController } from "@/controllers/file-controller"

const modelValue = defineModel<FileRelation>({ required: true })
const props = defineProps<{ deleteDisabledReason?: string }>()

const emit = defineEmits(["closePreview", "reloadPreview", "delete"])

const instance = getCurrentInstance()

const fileController: FileController = inject("fileController")!

async function removeFileRelation() {
  if (modelValue.value !== null && !props.deleteDisabledReason) {
    emit("delete", modelValue.value)
    closeMenu()
  }
}

async function downloadFile() {
  if (modelValue.value !== null) {
    const blob = await fetch(modelValue.value.file.url).then((res) => res.blob())
    const objUrl = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.download = modelValue.value.file.originalName
    a.href = objUrl
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(objUrl)
  }
  closeMenu()
}

let accumulatedDegreesAfterLastSync = 0
const roateLoader = ref(false)

async function rotateFile(degrees = 90) {
  if (modelValue.value !== null) {
    roateLoader.value = true

    accumulatedDegreesAfterLastSync = (accumulatedDegreesAfterLastSync + degrees) % 360

    await fileController.rotateFile(modelValue.value.file, accumulatedDegreesAfterLastSync)
    roateLoader.value = false
  }
  closeMenu()
  reloadPreview()
}
// Closes the Context Menu
function closeMenu() {
  instance!.parent!.emit("closeMenu")
}
function reloadPreview() {
  emit("reloadPreview")
}
</script>

<style scoped></style>
